import { PortalToolsPage } from '@features/portal-tools/components/PortalToolsPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/tools/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <PortalToolsPage />
}
